import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client';

// Server: collections/CollectionSetDto.java's PieceDto.
export type CollectionPieceDto = {
  itemCode: string;
  name: string;
  rarity: string;
  owned: boolean;
};

// Server: collections/CollectionSetDto.java. rewardItemCode is the item-kind grant's code out of
// the set's reward_json — null-safe (a set can complete with a badge-only reward).
export type CollectionSetDto = {
  code: string;
  landCode: string;
  name: string;
  pieces: CollectionPieceDto[];
  completed: boolean;
  rewardItemCode: string | null;
};

export type CollectionsDto = {
  sets: CollectionSetDto[];
};

export const collectionsKeys = {
  all: ['collections'] as const,
};

export const getCollections = () => apiFetch<CollectionsDto>('/collections');

/** `enabled` exists for `ItemDetailSheet`, which needs the sets only when the item in front of
 *  it is a material (nothing else can be a collection piece). The Bag opens that sheet on every
 *  item tap, so an unconditional fetch here would cost one request per item inspected, for an
 *  answer that could not apply to most of them. */
export function useCollections(enabled = true) {
  return useQuery({ queryKey: collectionsKeys.all, queryFn: getCollections, enabled });
}
